import { createSlice } from "@reduxjs/toolkit";
import {    add_incomeThunk } from "./thunk";

export const initialState = {
  addInComeData: [],
  addInComeError: '', // for error message
  addInComeLoading: false,
  
  
};

const Add_Annual_Income = createSlice({
  name: "Add_Annual_Income",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(add_incomeThunk.pending, (state) => {
      state.addInComeLoading = true ;
      state.addInComeData= [];
      state.addInComeError='';

  });
    builder.addCase(add_incomeThunk.fulfilled, (state, action) => {
        state.addInComeData = action.payload.data;
        state.addInComeLoading = false ;
    });
    builder.addCase(add_incomeThunk.rejected, (state, action) => {
      state.addInComeError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.addInComeLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Add_Annual_Income.actions

export default Add_Annual_Income.reducer;